// Splits a page of participants into consecutive runs of the same role. The API orders the
// page by role, so each role is one run here, and a run may continue on the next page.
const groupParticipantsByRole = (participants) =>
  participants.reduce((groups, participant) => {
    const lastGroup = groups[groups.length - 1];
    if (lastGroup && lastGroup.roleId == participant.role.id)
      lastGroup.participants.push(participant);
    else
      groups.push({ roleId: participant.role.id, roleName: participant.role.name, participants: [participant] });
    return groups;
  }, []);

export { groupParticipantsByRole };
